import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AzPaymentInfos',
  props: {
    alignment: { default: 'right' },
    size: { default: 'normal' }
  },
  setup(__props: any) {

const props = __props as { alignment: 'right' | 'center', size: 'small' | 'normal' };



const payments = ['cb', 'paypal', 'visa', 'mastercard'];

return { __sfc: true,props, payments }
}

})